/* eslint-disable eqeqeq */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Select,
} from '@mui/material';
import { memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import ShowroomHomeDetailToPrint from './EditablePrint';
import useAuth from 'hooks/useAuth';
import moment from 'moment';
import { useAppInfo } from 'context';

const EditablePrintModal = ({
  open,
  setOpen,
  homeData = {},
  objectData = {},
  blockName,
  applyDiscount,
  setApplyDiscount,
  discountId,
  setData,
  selectedDiscount,
  setSelectedDiscount,
  selectedHome,
}) => {
  const [{ user }] = useAuth();
  const [{ info }] = useAppInfo();
  const { t } = useTranslation();

  const [layers, setLayers] = useState('1');
  const [isPrinting, setIsPrinting] = useState(false);
  const [tabIndex, setTabIndex] = useState('link2d');
  const [tabTwoIndex, setTabTwoIndex] = useState('location');

  const phoneState = useState(info?.phone || '+998 78 555 00 77');
  const timeState = useState(moment().add(1, 'day').format('DD.MM.YYYY HH:mm'));
  const userState = useState(user?.user?.name || '');

  const printRef = useRef();
  const downloadRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => setIsPrinting(false),
    onBeforePrint: () => setIsPrinting(true),
    onBeforeGetContent: () => setIsPrinting(true),
    documentTitle: `${info?.name || ''}_${objectData?.name}_${blockName}_${homeData?.number}_uy`,
    pageStyle: `
      @media print {
        @page { size: landscape; margin: 0mm; }
      }
      body {
        -webkit-print-color-adjust: exact;
      }
    `,
  });

  const handleDownload = () => {
    const element = downloadRef.current;
    if (!element) return;

    const opt = {
      margin: 0,
      filename: `${info?.name || ''}_${objectData?.name}_${blockName}_${homeData?.number}_uy.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    };

    html2pdf().set(opt).from(element).save();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='xl'
      scroll='body'
      PaperProps={{ sx: { maxWidth: '1420px', width: '1420px' } }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <div className='flex justify-between items-center'>
          <div className='flex gap-2 items-center'>
            <i className='bi bi-columns' />
            <Select
              size='small'
              className='!h-[40px] !w-[180px]'
              value={layers}
              onChange={({ target }) => setLayers(target.value)}
            >
              <MenuItem value={'1'}>Bir ko‘rinishli</MenuItem>
              <MenuItem value={'2'}>Ikki ko‘rinishli</MenuItem>
            </Select>
            <Button
              startIcon={<i className='bi bi-printer text-lg mr-1' />}
              variant='base'
              size='small'
              onClick={handlePrint}
            >
              {t('common.button.print')}
            </Button>
            <Button
              startIcon={<i className='bi bi-download text-lg mr-1' />}
              variant='base'
              size='small'
              onClick={handleDownload}
            >
              Yuklab olish
            </Button>
          </div>
          <Button
            variant='onlyIcon'
            color='primary'
            onClick={handleClose}
            sx={{ minWidth: 40, width: 45 }}
          >
            <i className='bi bi-x text-3xl' />
          </Button>
        </div>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ padding: 0 }}>
        {homeData && Object.keys(homeData).length > 0 && (
          <div className='w-full'>
            <ShowroomHomeDetailToPrint
              ref={printRef}
              layers={layers}
              homeData={homeData}
              objectData={objectData}
              calculation={homeData?.calculations}
              blockName={blockName}
              selectedHome={selectedHome}
              applyDiscount={applyDiscount}
              setApplyDiscount={setApplyDiscount}
              discountId={discountId}
              setData={setData}
              selectedDiscount={selectedDiscount}
              setSelectedDiscount={setSelectedDiscount}
              tabIndex={tabIndex}
              setTabIndex={setTabIndex}
              tabTwoIndex={tabTwoIndex}
              setTabTwoIndex={setTabTwoIndex}
              phoneState={phoneState}
              timeState={timeState}
              userState={userState}
            />

            {/* Yuklab olish uchun yashirin versiyasi */}
            <div style={{ visibility: 'hidden', position: 'absolute', top: 0, left: 0 }}>
              <div ref={downloadRef}>
                <ShowroomHomeDetailToPrint
                  layers={layers}
                  homeData={homeData}
                  objectData={objectData}
                  calculation={homeData?.calculations}
                  blockName={blockName}
                  selectedHome={selectedHome}
                  applyDiscount={applyDiscount}
                  setApplyDiscount={setApplyDiscount}
                  discountId={discountId}
                  setData={setData}
                  selectedDiscount={selectedDiscount}
                  setSelectedDiscount={setSelectedDiscount}
                  tabIndex={tabIndex}
                  setTabIndex={setTabIndex}
                  tabTwoIndex={tabTwoIndex}
                  setTabTwoIndex={setTabTwoIndex}
                  phoneState={phoneState}
                  timeState={timeState}
                  userState={userState}
                />
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default memo(EditablePrintModal);
